export const formatoMonedaGraficasDisminuido = (number = 0) => {


    let formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
    });


    return formatter.format(number / 1000).replace(/^(\D+)/, '$ ' + (number < 0 ? "-" : "")) + "K"

}